import { checkWishlistIcon } from '@/braun/Controllers/BraunWishlistController';
import LazyLoadInfiniteResultsController from '@/braun/Controllers/Listing/LazyLoadInfiniteResultsController';
import ListingBackToPlpController from '@/braun/Controllers/Listing/ListingBackToPlpController';
import ProductTileHeightController from '@/braun/Controllers/Listing/ProductTileHeightController';
import UpdateResultsController from '@/braun/Controllers/Listing/UpdateResultsController';
import EVENTS from '@/utils/Constants/Events';
import PushProductCompare from '@/utils/Controllers/PushProductCompare';

export const rebindAll = () => {
  ProductTileHeightController();
  checkWishlistIcon();
  LazyLoadInfiniteResultsController();
  DLG.EVE.emit(EVENTS.LISTING.COMPARE.UPDATE);
};

export default () => {
  UpdateResultsController();
  ProductTileHeightController();
  ListingBackToPlpController();
  LazyLoadInfiniteResultsController();
  PushProductCompare();
};
